
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSailingOutlined as ObiVesselTypeSailingOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-sailing-outlined.js';
 
 
 

 
 export const ObiVesselTypeSailingOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-sailing-outlined',
   elementClass: ObiVesselTypeSailingOutlinedElement,
   events: {
     
   }
  });
 
 